var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Drawer, Skeleton, Flex, theme, Button, Typography, Card, Empty, Input, } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import { ConfigProvider, useConfig } from '../context/ConfigContext';
import { useRequiredContexts } from '../hooks/useRequiredContexts';
import { LocalizationContext } from '../context/LocalizationContext';
import { faAngleLeft } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSpaceStateQuery } from './hooks/useSpaceStateQuery';
import { useSpaceBookingLogic } from './hooks/useSpaceBookingLogic';
import { useSpaceCardUI } from './hooks/useSpaceCardUI';
import { useSpaceSearch } from './hooks/useSpaceSearch';
import { SpaceAmenities } from '../components/SpaceDetails/SpaceAmenities';
import { useState } from 'react';
import { LevelSelect } from './components/LevelSelect';
import { LocationSelect } from './components/LocationSelect';
import { COMPOSER_DRAWER_WIDTH } from '../constants/drawerSizes';
var Search = Input.Search;
export var SpaceBookingWrapper = function (_a) {
    var _b;
    var levelId = _a.levelId, locationId = _a.locationId, startTime = _a.startTime, endTime = _a.endTime, open = _a.open, onClose = _a.onClose, onAddSpace = _a.onAddSpace, spacesAdded = _a.spacesAdded, spaceIdsToHide = _a.spaceIdsToHide;
    var t = useTranslation('spaceBooking').t;
    var token = theme.useToken().token;
    var _c = useConfig(), tenantId = _c.tenantId, userContext = _c.userContext;
    var currentOrg = userContext.currentOrg;
    var _d = __read(useState(levelId), 2), selectedLevelId = _d[0], setSelectedLevelId = _d[1];
    var _e = __read(useState(locationId), 2), selectedLocationId = _e[0], setSelectedLocationId = _e[1];
    var _f = useSpaceStateQuery({
        levelId: selectedLevelId,
        startTime: startTime,
        endTime: endTime,
        spaceFilter: function () { return true; },
        skip: false,
        tenantId: tenantId,
    }), availabilityStateById = _f.availabilityStateById, spaceStateData = _f.data, loadingSpaceStateData = _f.loading;
    var _g = useSpaceBookingLogic({
        spaces: (_b = spaceStateData === null || spaceStateData === void 0 ? void 0 : spaceStateData.getLevelById) === null || _b === void 0 ? void 0 : _b.spaces,
        availabilityStateById: availabilityStateById,
        spacesAdded: spacesAdded,
        spaceIdsToHide: spaceIdsToHide,
    }), isSpaceBookable = _g.isSpaceBookable, sortedSpaces = _g.sortedSpaces;
    var _h = useSpaceSearch(sortedSpaces), searchQuery = _h.searchQuery, setSearchQuery = _h.setSearchQuery, searchResults = _h.searchResults;
    var level = spaceStateData === null || spaceStateData === void 0 ? void 0 : spaceStateData.getLevelById;
    var _j = useSpaceCardUI({
        onAddSpace: function (spaceId) {
            return onAddSpace(spaceId, selectedLevelId, selectedLocationId);
        },
    }), cardActions = _j.cardActions, getSpaceScheduleConfigurationText = _j.getSpaceScheduleConfigurationText;
    return (_jsxs(StyledDrawer, { title: _jsxs(Flex, { gap: 4, style: { alignItems: 'center' }, children: [_jsx(Button, { onClick: onClose, type: "text", icon: _jsx(FontAwesomeIcon, { icon: faAngleLeft }) }), t('add_space_title')] }), closeIcon: false, open: open, mask: false, size: COMPOSER_DRAWER_WIDTH, children: [_jsxs(Flex, { gap: 4, style: {
                    padding: 16,
                    paddingBottom: 4,
                    width: '100%',
                    minWidth: 0,
                    boxSizing: 'border-box',
                }, children: [_jsx(Flex, { style: { flex: 1, minWidth: 0 }, children: _jsx(LocationSelect, { value: selectedLocationId, onChange: function (locationId) {
                                setSelectedLocationId(locationId);
                                setSelectedLevelId(undefined);
                            }, currentOrgId: currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id, selectedLocationId: selectedLocationId }) }), _jsx(Flex, { style: { flex: 1, minWidth: 0 }, children: _jsx(LevelSelect, { locationId: selectedLocationId, value: selectedLevelId, onChange: function (levelId) { return setSelectedLevelId(levelId); }, selectedLevelId: selectedLevelId }) })] }), _jsx(Flex, { style: { padding: '8px 16px 0px', paddingBottom: 0 }, children: _jsx(SearchInput, { allowClear: true, onClear: function () { return setSearchQuery(''); }, value: searchQuery, onChange: function (e) { return setSearchQuery(e.target.value); }, placeholder: t('search'), name: "space-search" }) }), loadingSpaceStateData ? (_jsx(Flex, { vertical: true, gap: 16, style: { padding: 16, overflowY: 'auto', flex: 1 }, children: _jsx(Skeleton, { active: true }) })) : (_jsx(Flex, { vertical: true, gap: 16, style: { padding: 16, overflowY: 'auto', flex: 1 }, children: !sortedSpaces ? (_jsx(Empty, { description: t('no_spaces_found') })) : !searchResults || searchResults.length === 0 ? (_jsx(Empty, { description: t('space_not_found') })) : (searchResults.map(function (space, index) {
                    var _a;
                    var actions = cardActions(space, isSpaceBookable(space));
                    /* @TODO[Space] Move this component to common file */
                    return (_jsxs(SpaceCardWrapper, { token: token, index: index, actions: actions.length > 0 ? actions : undefined, children: [_jsxs(Flex, { gap: 12, vertical: false, align: "center", justify: "space-between", style: {
                                    width: '100%',
                                    alignSelf: 'flex-start',
                                    padding: '12px',
                                }, children: [_jsxs(Flex, { vertical: true, gap: 4, children: [_jsx(Typography.Text, { strong: true, children: space.name }), _jsx(Typography.Text, { type: "secondary", style: { fontSize: 12 }, children: t('formattedLevelAndLocation.name', {
                                                    levelName: level === null || level === void 0 ? void 0 : level.name,
                                                    locationName: (_a = level === null || level === void 0 ? void 0 : level.levelLocation) === null || _a === void 0 ? void 0 : _a.name,
                                                }) }), _jsx(SpaceAmenities, { capacity: (space === null || space === void 0 ? void 0 : space.capacity) || undefined, amenities: (space === null || space === void 0 ? void 0 : space.amenities.map(function (amenity) { return ({
                                                    id: amenity.id,
                                                    quantity: amenity.quantity,
                                                    amenityId: amenity.amenityId,
                                                    name: amenity.name,
                                                }); })) || [] })] }), space.image && (_jsx(SpaceImage, { width: 50, height: 50, src: space.image, alt: space.name }))] }), _jsx(Flex, { gap: 4, style: {
                                    alignItems: 'center',
                                    padding: '0 12px',
                                    paddingBottom: '12px',
                                }, color: token.colorTextSecondary, children: space.scheduleConfiguration &&
                                    getSpaceScheduleConfigurationText(space.scheduleConfiguration) })] }, space.id));
                })) }))] }));
};
var SpaceCardWrapper = styled(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-card-body {\n    padding: 0px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .ant-card-actions {\n    padding: 12px;\n    background: ", ";\n  }\n\n  .ant-card-actions {\n    li {\n      margin: 0px;\n    }\n  }\n"], ["\n  .ant-card-body {\n    padding: 0px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .ant-card-actions {\n    padding: 12px;\n    background: ", ";\n  }\n\n  .ant-card-actions {\n    li {\n      margin: 0px;\n    }\n  }\n"])), function (_a) {
    var token = _a.token;
    return token.colorBgLayout;
});
var SpaceImage = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 4px;\n  object-fit: cover;\n"], ["\n  border-radius: 4px;\n  object-fit: cover;\n"])));
var SearchInput = styled(Search)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 100%;\n"], ["\n  width: 100%;\n  max-width: 100%;\n"])));
/**
 * SpaceBooking component with context validation.
 *
 * This component validates that all required React contexts (e.g., ApolloProvider)
 * are present before rendering. If contexts are missing, it throws a helpful error
 * message with setup instructions.
 *
 * @example
 * ```tsx
 * import { ApolloProvider } from '@apollo/client';
 * import { SpaceBooking } from '@robinpowered/dashboard-apps-patterns';
 *
 * <ApolloProvider client={apolloClient}>
 *   <SpaceBooking
 *     config={config}
 *     levelId={levelId}
 *     startTime={startTime}
 *     endTime={endTime}
 *     timeZone="America/New_York"
 *   />
 * </ApolloProvider>
 * ```
 */
export var SpaceBooking = function (props) {
    // Validate required contexts before rendering
    useRequiredContexts();
    // If validation passes, render the internal component
    return (_jsx(LocalizationContext, { children: _jsx(ConfigProvider, { config: props.config, children: _jsx(SpaceBookingWrapper, { levelId: props.levelId, locationId: props.locationId, startTime: props.startTime, endTime: props.endTime, open: props.open, onClose: props.onClose, onAddSpace: props.onAddSpace }) }) }));
};
var StyledDrawer = styled(Drawer)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  .ant-drawer-header-title {\n    align-items: center;\n    display: flex;\n    flex-direction: row-reverse;\n  }\n\n  .ant-drawer-body {\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n  }\n"], ["\n  .ant-drawer-header-title {\n    align-items: center;\n    display: flex;\n    flex-direction: row-reverse;\n  }\n\n  .ant-drawer-body {\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
